<template>
    <div class="p-[16px]">
        <div class="mb-[12px]">
            <h2 class="text-[18px] text-[#2b2b2b] font-light">Mes requêtes</h2>
        </div>
        <div class="p-[6px] rounded-xl mb-[8px] bg-[#fff3ea] text-[#bf6d2e]">
            <p class="text-[12px] font-extralight">
                Veuillez appuyé sur le bouton "voir les détails" pour valider les requêtes effectués par les membres de votre équipes
            </p>
        </div>
        <CustomTable :data="permission" :columnsCustom="columnn" :load="isload">
            <template #other-filter>
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-x-[8px]">
                        <button v-on:click="getMembersRequest('refresh')" :disabled="table_load" class="size-[35px] border rounded-xl flex items-center justify-center">
                            <RefreshCw color="#2b2b2b" :size="16" strokeWidth="1.3" :class="{'animate-spin':actu_load}"/>
                        </button>
                        <div class="inline-block relative">
                            <button @click="show_advanced = !show_advanced" :class="['h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':show_advanced}]">
                                <SlidersHorizontal color="#2b2b2b" :size="16" strokeWidth="1.3"/>
                                Filtres
                            </button>
                            <Transition @before-enter="beforeEnterBox" @enter="enterBox" @leave="leaveBox">
                                <div v-if="show_advanced" id="advanced-filter" class="flex items-center gap-x-[12px] text-black font-light rounded-3xl p-6 shadow bg-white border absolute top-[120%] left-1/2 z-10">
                                    <div class="flex items-center gap-x-[8px]">
                                        <label for="date" class="font-light">Date:</label>
                                        <input type="date" v-model="date" name="date" class="h-[35px] w-[130px] cursor-pointer p-3 rounded-xl border focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] placeholder:text-mutedForeground"/>
                                    </div>
                                    <button v-on:click="getMembersRequest" :disabled="isload || actu_load" class="h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light">
                                        Actualiser
                                    </button>
                                    <button @click="show_advanced = !show_advanced" class="size-[25px] rounded-full border flex items-center justify-center">
                                        <X :size="16" strokeWidth="1.3"/>
                                    </button>
                                </div>
                            </Transition>
                        </div>
                    </div>
                    <button class="bg-[#3c41e9] font-light gap-x-[8px] rounded-xl text-white px-4 h-[35px] flex items-center justify-center">
                                <FolderUp :size="16"/>
                                Exporter
                    </button>
                </div>
            </template>
            <template #row-cell="slotProps">
                <span v-if="slotProps.cellNumber == 0" class="flex items-center gap-x-[8px]">
                    {{ slotProps.value }}
                </span>
                <span v-else-if="slotProps.cellNumber == 1">
                    <div class="flex items-center gap-x-[6px]">
                        <div class="size-[30px] rounded-full flex items-center justify-center bg-[#3474f4] text-white font-semibold">{{ slotProps.value.split('/')[0].trim()[0] }}</div>
                        <div class="flex flex-col items-start">
                            <span class="text-[12px]">{{ slotProps.value.split('/')[0] + " " + slotProps.value.split('/')[1] }}</span>
                            <span class="underline font-extralight text-[11px]">{{ slotProps.value.split('/')[2] }}</span>
                        </div>
                    </div>
                </span>
                <span v-else-if="slotProps.cellNumber == 2">
                    {{ formatDate(slotProps.value) }}
                </span>
                <span v-else-if="slotProps.cellNumber == 3">
                    <span class="px-4 py-1 rounded-xl">{{ formatDate2(slotProps.value) }}</span>
                </span>
                <span v-else-if="slotProps.cellNumber == 4" class="flex flex-wrap items-center justify-center">
                    <ValidationDetailUser :request="slotProps.value"/>
                </span>
                <span v-else>{{ slotProps.value }}</span>
            </template>
        </CustomTable>
    </div>
</template>
<script>
import API from "../../service/API.js";
import ValidationDetailUser from "@/components/btn/validation-detail-user.vue";
import gsap from "gsap";
import {createColumnHelper} from "@tanstack/vue-table";
import CustomTable from "@/components/tables/Custom-table.vue";
import Swal from 'sweetalert2';
import {SlidersHorizontal,RefreshCw,X,FolderUp} from "lucide-vue-next";
import { advancedFormat, convertirDateEnFrancais } from "@/utils/date-format.js";
const columnHelper = createColumnHelper();
const columnsRequest = [
  columnHelper.accessor(row => row.exception.type.label, {
    id: 'désignation',
    header: 'Désignation',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => `${row.exception.user.first_name}/${row.exception.user.last_name}/${row.exception.user.email}`, {
    id: 'employé',
    header: 'Employé',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.created_at.split('T')[0], {
    id: 'Date requête',
    header: 'Date requête',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => `${row.exception.date_start}T${row.exception.date_end}`, {
    id: 'Date de debut/fin',
    header: 'Date de début/fin',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row, {
    id: 'validation',
    header: 'Niveau de validation',
    cell: info => info.getValue(),
  })
];

export default {
    name:'MyPermission',
    components:{
        CustomTable,
        RefreshCw,
        ValidationDetailUser,
        X,
        SlidersHorizontal,FolderUp
    },
    data(){
        return {
            columnn: columnsRequest,
            isload : true,
            actu_load: false,
            active:"Non traité",
            date:"",
            show_advanced: false,
            permission:[]
        }
    },
    mounted(){
        this.getMembersRequest();
    },
    computed:{
    },
    methods:{
        formatDate(date){return convertirDateEnFrancais(date)},
        formatDate2(date){
            const [date1,date2] = date.split('T');
            return advancedFormat(date1,date2);
        },
        getMembersRequest(type = null){
            this.isload = true;
            if(type == 'refresh') this.actu_load = true;
            // const date = new Date();
            // const years = date.getFullYear();
            // const month = (date.getMonth() + 1).toString().padStart(2,0);
            // const day = date.getDate().toString().padStart(2,0);
            const id = localStorage.getItem("userId") ?? this.$store.getters.userId;
            const formData = new FormData();
            formData.append("sup",true);
            formData.append("date","")
            // formData.append("date",this.date ? `${this.date.split("-")[0]}-${this.date.split("-")[1]}-01` : `${years}-${month}-${day}`)
            API.post("/getMembersRequests/"+id,formData)
            .then((res)=>{
                if(!res.data.status) throw Error(res.data.message)
                this.permission = res.data["data"];
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{
                this.isload = false;
                if(type == 'refresh') this.actu_load = false;
            })
        },
        // validateOrRejectRequest(payload){
        //     const {id,cb,action,motif} = payload;
        //     cb();
        //     const formData = new FormData();
        //     formData.append("sup",true);
        //     formData.append("reject_motif",motif);
        //     API.post((action == "valid" ? "validate" : "reject")+"Request/"+id,formData)
        //     .then((response)=>{
        //         if(response.data["status"]){
        //             this.getMembersRequest();
        //             // toast.success("Succès",`Permission ${action == "valid" ? "validé" : "rejeté"} avec succès`,3000)
        //         }
        //     })
        //     .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
        //     .finally(()=>{
        //         cb();
        //     })
        // },
        // getActiveClass(libelle){
        //     return `px-4 py-3 rounded-md cursor-pointer ${libelle == this.active ? "bg-[#5357eb] text-white" : "bg-[#f9fafb] text-black"}`;
        // },
        // selectBar(libelle){
        //     this.active = libelle;
        // },
        // getActiveTab(libelle){
        //     return this.active == libelle
        // }
        beforeEnterBox(el){
            gsap.set(el, {
                xPercent: -50,
                scale: 0.97,
                y: -10,
                opacity: 0
            });
        },
        enterBox(el, done){
            gsap.to(el, {
                scale: 1,
                y: 0,
                opacity: 1,
                duration: 0.15,
                ease: "power2.out",
                onComplete: done,
            });
        },
        leaveBox(el, done){
            gsap.to(el, {
                scale: 0.95,
                y: -10,
                opacity: 0,
                duration: 0.15,
                ease: "power2.out",
                onComplete: done,
            });
        },
    }
}
</script>